export default __webpack_public_path__ + "static/media/complementary--traffic-queues--g1.798af17a.png";